import React from "react";
// mui
import { Avatar, Stack, Typography } from "@mui/material";
const JoinRequestSuccess = () => {
  return (
    <Stack
      gap="16px"
      width="100%"
      maxWidth="700px"
      marginX="auto"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
    >
      <Avatar
        src="/images/mail-sent.svg"
        variant="rounded"
        sx={{
          height: 400,
          width: "100%",
          aspectRatio: 1 / 1,
          border: "none",
          "& img": {
            objectFit: "contain",
          },
        }}
      />
      <Typography variant="subtitle1">تم ارسال طلب انضمامك بنجاح</Typography>
    </Stack>
  );
};

export default JoinRequestSuccess;
